import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "./Logo";

export const LegalPage = ({ title, updated, intro, sections, testid }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${title} · Sweet Results`;
  }, [title]);

  return (
    <div className="min-h-screen" data-testid={testid}>
      <header className="border-b border-white/10">
        <div className="max-w-3xl mx-auto px-5 py-5 flex items-center justify-between">
          <Logo />
          <Link to="/" data-testid="legal-back-link" className="inline-flex items-center gap-1.5 text-sm text-slate-300 hover:text-white">
            <ArrowLeft size={16} /> Back to site
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-14 sm:py-20">
        <p className="font-mono text-xs tracking-[0.25em] uppercase text-[#FF2A8D]">Last updated {updated}</p>
        <h1 className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl mt-4">{title}</h1>
        <p className="mt-6 text-slate-300 leading-relaxed">{intro}</p>
        <div className="mt-12 space-y-10">
          {sections.map((s, i) => (
            <section key={s.h}>
              <h2 className="font-display text-xl sm:text-2xl font-bold">
                <span className="text-[#5B95D6] font-mono text-sm mr-3">{String(i + 1).padStart(2, "0")}</span>{s.h}
              </h2>
              {s.p.map((t) => <p key={t.slice(0, 40)} className="mt-3 text-slate-300 leading-relaxed">{t}</p>)}
              {s.list && (
                <ul className="mt-3 space-y-2 list-disc pl-5 text-slate-300 marker:text-[#FF2A8D]">
                  {s.list.map((t) => <li key={t.slice(0, 40)}>{t}</li>)}
                </ul>
              )}
            </section>
          ))}
        </div>
        <p className="mt-16 pt-6 border-t border-white/10 text-sm text-slate-400">
          Questions? Email <a href="mailto:support@sweetresults.app" className="text-[#5B95D6] hover:underline">support@sweetresults.app</a>.
        </p>
      </main>
    </div>
  );
};
